<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Aquaculture</a></li>
          <li><a>Soil Type</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Soil Type</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by soil type name"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <!--Soil type block-->
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let soiltype of soilTypesList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ soiltype && soiltype.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Updated At: {{soiltype && soiltype.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/descriptio-card-icon.svg">
                  <span
                    class="description">{{soiltype && soiltype.description ? soiltype && soiltype.description : 'NA'}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Abbreviation:</span>
                  <span class="text">{{ soiltype?.abbreviation || "NA" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Business Type" (click)="getSoilTypeById(soiltype.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Soil type Not Found</div>
        <!-- Soil type block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="addSoilTypeForm" novalidate>
              <div class="form-header">
                <div class="form-title">Soil Type</div>
                <button class="add-update-submit-button" (click)="addUpdateSoilType()" [disabled]="soilTypeDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="activityName" type="text" formControlName="name" autocomplete="off" placeholder="Enter name"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(soilTypeFormValidation.name.dirty || soilTypeFormValidation.name.touched || submitted) && soilTypeFormValidation.name.errors">
                    <i> {{soilTypeFormValidation.name.hasError('required') ? 'Soil type is required.': soilTypeFormValidation.name.hasError('minlength')? 'Minimum 3 characters required.': soilTypeFormValidation.name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : soilTypeFormValidation.name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Abbreviation</mat-label>
                  <input matInput id="unitCode" type="text" autocomplete="off" formControlName="abbreviation" placeholder="Enter abbreviation"/>
                  <mat-hint><i>10 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(soilTypeFormValidation.abbreviation.touched || soilTypeFormValidation.abbreviation.dirty || submitted) && soilTypeFormValidation.abbreviation.errors">
                    <i>{{ soilTypeFormValidation.abbreviation.hasError('required') ? 'Abbreviation is required.' : soilTypeFormValidation.abbreviation.hasError('maxlength')? 'Maximum 10 characters allowed.': soilTypeFormValidation.abbreviation.hasError('pattern')? 'Special characters are not allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="activityDescription" rows="3" formControlName="description" autocomplete="off" placeholder="Description"></textarea>
                  <mat-hint><i>Up to 200 characters</i></mat-hint>
                  <mat-error *ngIf="(soilTypeFormValidation.description.dirty || soilTypeFormValidation.description.touched || submitted) && soilTypeFormValidation.description.hasError('maxlength')">
                    <i>Maximum 200 characters allowed.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
